import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import { DEFAULT_LAT, DEFAULT_LNG } from '@/helpers/constants/app';
let GoogleMaps = class GoogleMaps extends Mixins(AlertMixin) {
    constructor() {
        super(...arguments);
        this.markers = [
            {
                lat: this.getLat().toString(),
                lng: this.getLng().toString(),
            },
        ];
    }
    getLat() {
        return this.lat || DEFAULT_LAT;
    }
    getLng() {
        return this.lng || DEFAULT_LNG;
    }
    getPosition(marker) {
        return {
            lat: parseFloat(marker.lat),
            lng: parseFloat(marker.lng),
        };
    }
    mark(event) {
        this.markers.pop();
        this.markers.push({
            lat: parseFloat(event.latLng.lat()),
            lng: parseFloat(event.latLng.lng()),
        });
        this.$emit('markLocation', this.markers);
    }
    setPlace(place) {
        this.markers.pop();
        this.markers.push({
            lat: parseFloat(place.geometry.location.lat()),
            lng: parseFloat(place.geometry.location.lng()),
        });
        this.$emit('markLocation', this.markers);
    }
};
__decorate([
    Prop({ type: Number, required: true })
], GoogleMaps.prototype, "lat", void 0);
__decorate([
    Prop({ type: Number, required: true })
], GoogleMaps.prototype, "lng", void 0);
GoogleMaps = __decorate([
    Component
], GoogleMaps);
export default GoogleMaps;
